import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import UserBankAcountModel from '../../models/UserBankAcountModel';
import AppNotification from '../../helpers/AppNotification';
import BankModel from '../../models/BankModel';
import CurrencyInput from '../global/CurrencyInput';
import { useDispatch } from 'react-redux';
import { setShowPreloader } from '../../redux/action';
import { RiWallet3Line, RiCloseLine, RiCheckLine } from 'react-icons/ri';

const validationSchema = Yup.object().shape({
    amount: Yup.number()
        .required('Vui lòng nhập số tiền')
});

function ModalDepositApp(props) {
    const dispatch = useDispatch();

    const [amountMessage, setAmountMessage] = useState({
        total: '',
        fee: '',
        total_order: '',
    });

    const initialValues = {
        amount: '',
        user_bank_account_id: props.user_bank_account_id,
    };

    const handCloseModal = () => {
        setAmountMessage({
            total: '',
            fee: '',
        });
        props.onHide();
    };

    const handleSubmit = (values) => {
        dispatch(setShowPreloader(true));
        BankModel.depositApp(values).then(function (res) {
            dispatch(setShowPreloader(false));
            if (res.success === true) {
                Swal.fire({
                    icon: "success",
                    title: "Nạp tiền vào tài khoản thành công!",
                    showConfirmButton: false,
                    timer: 2000
                });
                props.onHide();
                if (props.reloadPage) props.reloadPage();
            }
        }).catch(function (err) {
            dispatch(setShowPreloader(false));
            Swal.fire({
                icon: "error",
                title: 'Nạp tiền vào tài khoản thất bại!',
                showConfirmButton: false,
                timer: 2000
            });
            console.log(err);
        });
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <RiWallet3Line className="me-2" style={{ color: 'var(--wus-text)' }} size={19} />
                    Nạp Tiền vào Tài khoản {props.bankName}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, setFieldValue }) => (
                        <Form>
                            <div className='p-2 mb-3'>
                                <div className="d-flex justify-content-between align-items-center pb-2" style={{ borderBottom: '1px solid var(--wus-border)' }}>
                                    <span style={{ color: "var(--wus-text-muted)", fontSize: "13.5px" }}>Tình trạng tài khoản:</span>
                                    <div>
                                        {props.BankStatus === 1 ? (
                                            <span className="status-pill ok">
                                                <span className="status-dot ok"></span>
                                                Hoạt động
                                            </span>
                                        ) : (
                                            <span className="status-pill expired">
                                                <span className="status-dot expired"></span>
                                                Đang Tắt
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3 px-2">
                                <label htmlFor="amount" className="form-label mb-2">
                                    <span>Nhập số tiền nạp vào App</span> <span className="text-danger">*</span>
                                </label>
                                {
                                    (props.PackAge && props.PackAge.max_deposit_app == -1) &&
                                        <CurrencyInput
                                            type="text"
                                            className={`form-control ${errors.amount && touched.amount ? 'is-invalid' : ''}`}
                                            autoFocus
                                            placeholder="Nhập số tiền..."
                                            onChange={e => {
                                                let value = e.target.value || "";
                                                value = value.replaceAll(',', '');
                                                setFieldValue("amount", value);
                                            }}
                                        />
                                }
                                {(props.is_UserPackage && props.PackAge && (props.is_UserPackage.total_deposit_app < props.PackAge.max_deposit_app) &&
                                    <CurrencyInput
                                        type="text"
                                        className={`form-control ${errors.amount && touched.amount ? 'is-invalid' : ''}`}
                                        autoFocus
                                        placeholder="Nhập số tiền..."
                                        onChange={e => {
                                            let value = e.target.value || "";
                                            value = value.replaceAll(',', '');
                                            setFieldValue("amount", value);
                                        }}
                                    />)
                                    ||
                                    (props.is_UserPackage && props.PackAge && (props.is_UserPackage.total_deposit_app >= props.PackAge.max_deposit_app) && (props.PackAge.max_deposit_app != -1) &&
                                        <CurrencyInput
                                            type="text"
                                            className={`form-control ${errors.amount && touched.amount ? 'is-invalid' : ''}`}
                                            autoFocus
                                            placeholder="Nhập số tiền..."
                                            onChange={e => {
                                                let value = e.target.value || "";
                                                value = value.replaceAll(',', '');
                                                setFieldValue("amount", value);
                                            }}
                                        />)
                                    ||
                                    (props.is_UserPackage == null &&
                                        <CurrencyInput
                                            type="text"
                                            className={`form-control ${errors.amount && touched.amount ? 'is-invalid' : ''}`}
                                            autoFocus
                                            placeholder="Nhập số tiền..."
                                            onChange={e => {
                                                let value = e.target.value || "";
                                                value = value.replaceAll(',', '');
                                                setFieldValue("amount", value);
                                            }}
                                        />
                                    )
                                }
                                <Field
                                    type="hidden"
                                    id="amount"
                                    name="amount"
                                />
                                {errors.amount && touched.amount && (
                                    <div className="invalid-feedback d-block">{errors.amount}</div>
                                )}
                            </div>
                            <div className="modal-footer px-0 pb-0">
                                <button type="button" className="btn btn-secondary" onClick={handCloseModal}>
                                    <RiCloseLine className="me-1" size={16} />
                                    Đóng
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    <RiCheckLine className="me-1" size={16} />
                                    Xác nhận nạp
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalDepositApp;
